import { Box, FormControl, TextareaAutosize, Typography } from "@mui/material";
import { IResolutionCommentProps } from "../types/interfaces/IResolutionCommentProps";
import { ChangeEvent, useState } from "react";

//This component is responsible for rendering a resolution response comment control.
//Props: The comment string and onCommentChange function are passed in from the caller.
const ResolutionComment: React.FC<IResolutionCommentProps> = ({ comment, onCommentChange }) => {

    const [text, setText] = useState<string | null>(comment);
    if (comment !== text) setText(comment);
    const maxLength = 2100;
    const placeholderText = `${maxLength} Character Limit`;

    let remainingChars = maxLength;
    if (text !== null && text.length > 0) {
        remainingChars = maxLength - text.length;
    }

    //Function to handle a resolution response comment change.
    const commentChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        setText(e.target.value.slice(0, maxLength));
        onCommentChange(e.target.value);
    }

    return (
        <>
            <Typography variant="h6" color="primary.dark" component="div">
                <Box sx={{ fontWeight: 'bold' }}>Note</Box>
            </Typography>
            <FormControl sx={{ m: 1, width: "60%", minWidth: 255 }}>
                <TextareaAutosize
                    id="note"
                    minRows={3}
                    placeholder={placeholderText}
                    maxLength={maxLength}
                    value={text || ''}
                    onChange={(e) => commentChange(e)} />
                <Typography variant="body2" align="right">
                    {remainingChars} characters left
                </Typography>
            </FormControl>
        </>
    );
}

export default ResolutionComment;